import React, { useRef, useState, useEffect } from "react"
import "./map.css";
import MapContext from "./mapContext";
import * as ol from "ol";
import * as control from 'ol/control';
import 'ol/ol.css';

const Map = ({ children, zoom, center, onSetZoom, extent, onSetMap, projection, activeTool }) => {
  const mapRef = useRef();
  const [map, setMap] = useState(null);
  //called by parent
   /*eslint-disable no-unused-vars*/
  function setPosition(dataExtent) {
    if (dataExtent)
      map.getView().fit(dataExtent, map.getSize());
  }
  /*eslint-enable no-unused-vars*/
  
  const getCursorClass = () => {
    if (['start', 'end', 'areaPolygon', 'obstacles', 'points'].includes(activeTool)) {
      return 'cursor-crosshair';
    }
    return 'cursor-auto';
  }

  // on component mount
  useEffect(() => {
    let mapOptions = undefined;
    if (zoom && center && projection)
      mapOptions = { zoom, center, projection };
    let options = {
      view: new ol.View(mapOptions),
      layers: [],
      controls: control.defaults({ attribution: false, zoom : true, rotate: false }),
      overlays: []
    };
    let mapObject = new ol.Map(options);

    onSetMap(mapObject);
    onSetZoom(mapObject.getView().getZoom(), true);

    mapObject.getView().on('propertychange', function(e) {
      switch (e.key) {
         case 'resolution':
          onSetZoom(mapObject.getView().getZoom(), false);
           break;
        default:
          break;           
      }
   });

    mapObject.setTarget(mapRef.current);
    setMap(mapObject);
    return () => mapObject.setTarget(undefined);
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps
  // zoom change handler
  useEffect(() => {
    if (!map) return;
    if (!zoom) return;
    map.getView().onSetZoom && map.getView().onSetZoom(zoom, false);
  }, [zoom]); // eslint-disable-line react-hooks/exhaustive-deps
  // center change handler
  useEffect(() => {
    if (!map) return;
    if (!center) return;
    map.getView().setCenter(center)
  }, [center]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <MapContext.Provider value={{ map }}>
      <div ref={mapRef} className={"ol-map " + getCursorClass()}>
        {children}
      </div>
    </MapContext.Provider>
  )
}
export default Map;